module.exports = __webpack_public_path__ + "img/hosting_banner.5c9fc185.jpg";